<template>
	<div class="sale-view">
		<b-card-group>
			<b-card header-tag="header" footer-tag="footer" class="saleViewCard">
				<div slot="header" class="top-card">
					<span class="hide-print">
						<h5>{{$t('sale.title')}} <strong> №:{{ item.saleNumber}}</strong> - {{ item.shopName }}</h5>
					</span>
					<!-- <a style="font-size: 16px;" class="mr-3" :href="`${root_api}/excel-parser/list-from-sale-optom/${item.id}`" disabled
								download>{{ $t('excel-export.download-excel') }}</a> -->
					<button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">×</span>
					</button>
				</div>
				<div class="box box-solid">
					<div class="box-body">
						<div class="row">
							<div :class="[item.action == 'OPTOM_SAVDO' ? 'col-sm-4 pr-0' : 'col-sm-5 pr-0']">

							</div>
							<div class="col-sm-2 pl-0">

							</div>
							<div class="col-sm-3 pl-0">

							</div>
							<div class="col-sm-3 pl-0" v-if="item.action == 'OPTOM_SAVDO'">

							</div>
							<div class="col-sm-2 pl-0" v-else>

							</div>
						</div>
						<div class="row">
							<div class="col-4">

							</div>
							<div class="col-2">

							</div>
							<div class="col-3">

							</div>
						</div>
					</div>
					<div class="box-body">
						<b-row>
							<b-col>
								<span :class="[item.action == 'OPTOM_SAVDO' ? 'pr-2' : 'pr-4']"><strong>{{$t('pricing.costDate')}}:</strong> {{ item.updateDate }} </span><br>
								<span><strong>{{$t('xAtchot.cashier')}}:</strong> {{ item.cashierFullName}} </span><br>
								<strong>{{ $t('contract.comment') }}: </strong><span>{{ item.comment }}</span>
							</b-col>
							<b-col>
								<strong>{{$t('pos.sum')}}: </strong>{{ item.amountOfPaymentUzs | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}<br>
								<strong>{{$t('sale.sum-skidka')}}: </strong>{{ item.amountOfAfterPromoUzs | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}<br>
								<strong>Скидка (на каждый товар): </strong>{{ afterPromotionSum((item.saleItems&&item.saleItems.length>0)?item.saleItems[0]:{}) > 0 ? afterPromotionSum(item.saleItems[0]) : afterPromotionPercentage(item.saleItems[0]) }} {{ afterPromotionSum(item.saleItems[0]) > 0 ? currencyForSaleView : '%' }}<br>
								<strong>{{$t('pos.no-check')}}: </strong>{{ item.customPromotionDiscount ? item.customPromotionDiscount : 0 }} {{ item.customPromotionType == '%' ? '%' : currencyForSaleView }}
							</b-col>
							<b-col>
								<b-row>
									<b-col><strong>Наличные деньги: </strong></b-col>
									<b-col><span v-for="(val, index) in item.paymentMap.CASH" :key="index"><span>{{val.value}} {{val.currencyCode}}</span><br></span></b-col>
								</b-row>
								<hr class="mt-1 mb-1">
								<b-row>
									<b-col><strong>Банковская карта: </strong></b-col>
									<b-col><span v-for="(val, index) in item.paymentMap.BANK_CARD" :key="index"><span>{{val.paymentTypeCode}} {{val.value}} {{val.currencyCode}}</span><br></span></b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col v-if="item.flight1 && item.flight1.length > 0 || item.ticket1 && item.ticket1.length > 0" >
								<b>Билет и номер рейса: </b>
								<span v-if="item.flight1">{{(item.flight1).slice(0, 25)}} , &nbsp;</span><span v-if="item.ticket1">  {{(item.ticket1).slice(0, 30)}}</span>
							</b-col>
							<b-col v-if="item.numberCard1 && item.numberCard1.length > 0">
								<b>Номер карточки:</b>  &nbsp;
								<span>{{item.numberCard1}}</span>
							</b-col>

						</b-row>
					</div>
				</div>
				<hr class="mt-2 mb-2">


				<table class="table table-bordered table-striped table-hover">
					<thead>
					<tr>
						<th class="text-center">№</th>
						<th class="text-center">{{ $t('sale.products') }}</th>
						<th class="text-center">{{ $t('goods.special-barcode') }}</th>
						<th class="text-center">{{ $t('kirim.expirationDate') }}</th>
						<th class="text-center">{{ $t('sale.kol-vo') }}</th>
						<th class="text-center">{{ $t('incomes.create.price') }}</th>
						<th class="text-center">{{ $t('promo-to-product.discount') }}</th>
						<th class="text-center">{{ $t('promo-to-product.discount') }} %</th>
						<th class="text-center">{{ $t('pos.promo') }}</th>
					</tr>
					</thead>
					<tbody v-if="item.saleItems.length > 0 || item.productItems.length > 0">
						<tr v-for="(tmp1, index) in item.productItems" :key="`items1-${index}`">
							<td class="text-center">{{ index+1 }}</td>
							<td class="text-left pl-2">{{ tmp1.name }}</td>
							<td class="text-center">{{ tmp1.barcode }}</td>
							<td class="text-center">{{ tmp1.termOfItem ? tmp1.termOfItem : '' }}</td>
							<td class="text-center">{{ tmp1.count + (tmp1.unitName ? tmp1.unitName : 'dona') }}</td>
							<td class="text-center">{{ tmp1.priceUzs | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}</td>
							<td class="text-center">{{ 0 | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}</td>
							<td class="text-center">{{ 0 }} %</td>
							<td class="text-center">{{ tmp1.priceUzs | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}</td>
						</tr>
						<tr v-for="(tmp, index) in item.saleItems" :key="`items-${index}`">
							<td class="text-center">{{ item.productItems.length+index+1 }}</td>
							<td class="text-left pl-2">{{ tmp.name }}</td>
							<td class="text-center">{{ tmp.barcode }}</td>
							<td class="text-center">{{ tmp.termOfItem ? tmp.termOfItem : '' }}</td>
							<td class="text-center">{{ tmp.count + (tmp.unitName ? tmp.unitName : 'dona') }}</td>
							<td class="text-center">{{ tmp.priceUzs | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}</td>
							<td class="text-center">{{ afterPromotionSum(tmp) | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}</td>
							<td class="text-center">{{ afterPromotionPercentage(tmp) }} %</td>
							<td class="text-center">{{ tmp.priceAfterUzs | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="13" class="text-center"><b>{{ $t('empty') }}</b></td>
						</tr>
					</tbody>
				</table>
			</b-card>
		</b-card-group>
	</div>
</template>
<script>

    export default {
        name: 'SaleView',
        props: ['item', 'currencyForSaleView'],
        data() {
            return {
				ticed:'',
				root_api: process.env.VUE_APP_ROOT_API
			}
        },
        computed: {
            computedFields() {
                return [
                    {
                        key: 'id',
                        label: '№',
                        sortable: true,
                        class: 'saleViewId'
                    },
                    {
                        key: 'Продукт',
                        label: this.$t('sale.products'),
                        sortable: true,
                        class: 'productInfo'
                    },
                    {
                        key: 'barcode',
                        label: this.$t('goods.special-barcode'),
                        sortable: true
                    },
                    {
                        key: 'termOfItem',
                        label: this.$t('kirim.expirationDate'),
                        sortable: true
                    },
                    {
                        key: 'count',
                        label: this.$t('sale.kol-vo'),
                        sortable: true,
                        'class': 'textAlignCenter'
                    },
                    {
                        key: 'price',
                        label: this.$t('incomes.create.price'),
                        'class': 'textAlignCenter'
                    },
                    {
                        key: 'pul',
                        label: this.$t('promo-to-product.discount')
                    },
                    {
                        key: 'percentage',
                        label: this.$t('promo-to-product.discount')+' %'
                    },
                    {
                        key: 'discountPriceUzs',
                        label: this.$t('pos.promo'),
                        'class': 'textAlignCenter'
                    },
                ]
            },
        },
        methods: {
			close() {
				this.$emit("close");
			},
            afterPromotionSum(item) {
                let promoparam;
                if (item && item.promotions && item.promotions.length>0) {
                    for (let i = 0; i < item.promotions.length; i++) {
                        if (item.promotions[i].type == "PUL") {
                            promoparam = item.promotions[i].value
                        }
                    }
                    return promoparam;
                }

            },
			payments(item) {
				let promoparam;
				if (item && item.promotions && item.promotions.length>0) {
					for (let i = 0; i < item.promotions.length; i++) {
						if (item.promotions[i].type == "PUL") {
							promoparam = item.promotions[i].value
						}
					}
					return promoparam;
				}

			},
            afterPromotionPercentage(item) {
                let promoparam1;
                if (item && item.promotions && item.promotions.length>0) {
                    for (let i = 0; i < item.promotions.length; i++) {
                        if (item.promotions[i].type == "%") {
                            promoparam1 = item.promotions[i].value
                        }
                    }
                    return promoparam1;

                }
            },
        },
		watch:{},
    }
</script>
<style scoped lang="scss">
	.top-card {
		display: flex;
		justify-content: space-between;
		align-item: center;
	}

	.saleViewCard {
		min-height: unset;
	}

	.generalTableClass {
		table {
			th.productInfo {
				width: 21% !important;
			}
		}
	}
</style>
